import { useId } from "react";

export default function PlansIconNew() {
  const id = useId();
  const gradId = `grad-${id}`;
  const clipId = `clip-${id}`;

  return (
    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath={`url(#${clipId})`}>
        <path
          fill={`url(#${gradId})`}
          d="M10.379 15.0102H3.86875C3.09555 15.0102 2.46875 14.3834 2.46875 13.6102V5.14016M9.01989 2.2002H5.54889C4.96899 2.2002 4.49889 2.6703 4.49889 3.2502V12.8502C4.49889 12.9607 4.58843 13.0502 4.69889 13.0502H12.3389C12.9188 13.0502 13.3889 12.5801 13.3889 12.0002V6.56919C13.3889 6.55062 13.3815 6.53282 13.3684 6.51969L9.06939 2.2207C9.05626 2.20757 9.03846 2.2002 9.01989 2.2002Z"
          stroke="#4D4745"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_6409_7792">
          <rect width="14" height="14" fill="white" transform="translate(1 1.5)" />
        </clipPath>
      </defs>
    </svg>
  );
}
